import { WHOAMI, MENU_ACTIVE_ACTION, GET_CONTACTS_LIST, SET_CONTEXT, SET_SELECTED_BOTTOM_TAB } from '../actions/types';

const initialState = {
	whoami: '',
	ward: '',
	menu: '',
	contacts_list: [],
	context: {},
	selectedBottomTab: null,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case WHOAMI:
			return {
				...state,
				whoami: action.payload,
			};
		case MENU_ACTIVE_ACTION:
			return {
				...state,
				menu: action.payload.menu,
			};
		case GET_CONTACTS_LIST:
			return {
				...state,
				contacts_list: action.payload,
			};
		case SET_CONTEXT:
			return {
				...state,
				context: {
					...state.context,
					...action.payload,
				},
			};
		case SET_SELECTED_BOTTOM_TAB:
			return {
				...state,
				selectedBottomTab: action.payload,
			};
		default:
			return state;
	}
}
